






import Vue from "vue";
import MainLayout from "@/layouts/MainLayout.vue";
import Button from "@/components/ui/Button.vue";
import VTooltip from "v-tooltip";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "./theme/generics.scss";
import "animate.css";

Vue.use(VueToast);
Vue.use(VTooltip);

export default Vue.extend({
	name: "App",
	components: {
		MainLayout,
		Button,
	},
});
